import React, { useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  Tabs,
  Tab,
  Divider,
  Stack,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import "../styles/layout/LandingPage.scss";
import PageIntro from "../components/pageintro";
import WhyTecloqCards from "../components/whytecloqcards";

const whydata = [
  {
    src: "/assets/DataAnalytics/PowerBI/why1.png",
    alt: "why1",
    title: "Domain Experience",
    description:
      "Tecloq as one of the leading Power BI Consulting Firms providing one-of-a-kind Power BI consulting services to assist you in developing custom dashboards, custom visualizations, and actionable reports for making data-driven decisions.",
  },
  {
    src: "/assets/DataAnalytics/PowerBI/why2.png",
    alt: "why1",
    title: "Through-out Support",
    description:
      "Our experts at Tecloq – Power BI Consulting Company devise an appropriate strategy and walk you through every step of the process, from developing a roadmap to developing a data plan to assess and execute a cutting-edge BI platform that suits your needs.",
  },
  {
    src: "/assets/DataAnalytics/PowerBI/why3.png",
    alt: "why1",
    title: "Improved Efficiency",
    description:
      "Tecloq is one of the top Power BI Consulting Firms assisting you in making the most of Power BI so you can easily dig into advanced analytics for better insight. It becomes feasible to predict outcomes and prevent failures of your assets or activities quickly and simply.",
  },
];


const tabsData = [
  {
    label: "HR",
    title: "HR",
    content:
      "Power Bi Sales Dashboards for presenting essential and actionable data on sales pipeline, growth, quarterly forecasts, account management, and more, allowing you to make data-driven decisions quickly.",
    image: "/assets/DataAnalytics/PowerBI/hr.webp",
  },
  {
    label: "HEALTHCARE",
    title: "HEALTHCARE",
    content:
      "Power Bi Marketing Dashboards provide insightful visualizations of key metrics regarding your customer journeys, website performance, social media presence, and digital media expenditures.",
    image: "/assets/DataAnalytics/PowerBI/hr.webp",
  },
  {
    label: "INVENTORY",
    title: "INVENTORY",
    content:
      "Power Bi Financial Dashboards to bring data together and maximise the effect of your time and resources while securely sharing the information that drives corporate strategy.",
    image: "/assets/DataAnalytics/PowerBI/hr.webp",
  },
  {
    label: "WEB ANALYTIC",
    title: "WEB ANALYTIC",
    content:
      "Power Bi Customer Service Dashboards to analyze key figures and trends in business, including customer satisfaction, response time, and SLA compliance. Set notifications to keep everyone informed, provide alerts if metrics fall short of goals, and coordinate efforts across teams.",
    image: "/assets/DataAnalytics/PowerBI/hr.webp",
  },
];

const PowerBI = () => {
  // State to track the active tab
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to handle tab change
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/DataAnalytics/PowerBI/background.webp"}
        subheading={"Integrated strategy for your BI and data efforts"}
        heading={"Power BI Consulting Services"}
        desc={"Architecting Future-Ready Data Landscapes"}
      />

      <Paper
        elevation={0}
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          padding: { xs: "4%", md: "5%" },
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontFamily: "Inter",
            fontStyle: "normal",
            fontSize: { xs: "14px", sm: "16px", md: "22px" },
            fontWeight: "lighter",
            margin: { xs: "4% 5%", md: "2% 5% 2% 5%" },
            lineHeight: { xs: "20px", sm: "24px", md: "28px" },
          }}
        >
          Business intelligence is essential to success due to how
          data-intensive firms are. Power BI Services provided by Tecloq’s Power
          BI Experts assist businesses in finding insights buried in their data
          and enhancing data exploration. Tecloq is one of the leading Power BI
          Consulting firms with 7+ years of experience in providing top-notch
          Power BI Consulting Services to businesses in a variety of verticals
          and of different sizes. Utilizing Power BI Services becomes simpler
          for your teams with the help of our Power BI Consultants, who create
          implementation plans and identify any necessary training requirements.
          We help businesses realize the value of their organizational data with
          our Power BI Consulting Services.
        </Typography>

        <div
          style={{ display: "flex", justifyContent: "center", marginTop: "2%" }}
        >
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "100%",
              maxWidth: "180px",
              height: "48px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              color: "inherit",
              padding: "0 2%",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "16px",
                letterSpacing: "0.5px",
                fontWeight: "700",
              }}
            >
              Contact Us
            </div>

            <div
              className="submitBtn__Arrow"
              style={{
                width: "28px",
                height: "28px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "5%",
              }}
            >
              <ArrowForwardIcon sx={{ fontSize: "18px" }} />
            </div>
          </Link>
        </div>
      </Paper>

      <Box sx={{ margin: "8% 2% 5% 2%", padding: "0 !important" }}>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "22px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "1%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "8%", sm: "6%", md: "5%" }, // Responsive padding
            textAlign: "center", // Ensures alignment on smaller screens
          }}
        >
          Interactive Dashboards made by Power BI Experts
        </Typography>

        {/* Tabs */}
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "3%" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            centered
            sx={{
              width: "85%",
              "& .MuiTabs-flexContainer": {
                justifyContent: "center", // Center tabs when they fit
                // gap: { xs: "4px", sm: "8px" }, // Add small gaps for better spacing on smaller screens
              },
              "& .MuiTab-root": {
                fontSize: { xs: "10px", sm: "14px", md: "24px" }, // Shrink font size on smaller screens
                flexGrow: 1, // Allows tabs to shrink
                minWidth: 0, // Prevents fixed width and allows shrinking
                maxWidth: "240px", // Controls max width of each tab
                textTransform: "none",
                borderRadius: "1px",
                backgroundColor: "#E8E8E8", // Default color when not selected
                color: "#000", // Text color when not selected
                transition: "all 0.1s ease",
                padding: { xs: "4px 8px", sm: "6px 12px" }, // Adjust padding for better touch targets on mobile
                height: { xs: "36px", sm: "48px" }, // Adjust height for better touch experience
              },
              "& .MuiTab-root.Mui-selected": {
                backgroundColor: "#F005A2", // Active tab color
                color: "#FFFFFF", // Text color for selected tab
                fontWeight: "bold",
              },
              "& .MuiTabs-indicator": {
                display: "none", // Hide default Material-UI underline
              },
            }}
          >
            {tabsData.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                sx={{
                  fontFamily: "Inter",
                  fontSize: { xs: "12px", md: "46px" }, // Responsive font size
                }}
              />
            ))}
          </Tabs>
        </Box>
        {/* Divider */}
        <Divider
          sx={{ marginTop: "10px", backgroundColor: "#000000", height: "0.1%" }}
        />
        {/* Tab Content Below Divider */}
        <Box sx={{ marginTop: "5%", padding: "0 20px" }}>
          {tabsData.map((tab, index) =>
            selectedTab === index ? (
              <Stack key={index} spacing={3} alignItems="center">
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "normal",
                    fontFamily: "Inter",
                    fontSize: { xs: "14px", md: "20px" },
                    color: "#000000",
                    textAlign: "center",
                    lineHeight: "1.5",
                  }}
                >
                  {tab.content}
                </Typography>
                <img
                  src={tab.image}
                  alt={tab.title}
                  style={{
                    width: "100%",
                    maxWidth: "600px",
                    height: "auto",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </Stack>
            ) : null
          )}
        </Box>
      </Box>

      <Box>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "8%", sm: "6%", md: "5%" }, // Responsive padding
            textAlign: "center", // Ensures alignment on smaller screens
          }}
        >
          Why Power BI Consulting Services?
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: { md: "60px" },
            flexWrap: "wrap",
            gap: "20px",
            marginBottom: "5%",
          }}
        >
          {[
            {
              img: "/assets/DataAnalytics/PowerBI/integration.png",
              title: "Seamless Integration",
              desc: "With Power BI, you can simply deploy analytics and reporting capabilities into your current business environment and seamlessly integrate dynamic visuals into your applications.",
            },
            {
              img: "/assets/DataAnalytics/PowerBI/time.png",
              title: "Speed and Storage",
              desc: "By moving an existing BI system to a robust cloud environment with Power BI, memory and speed limitations are removed, guaranteeing that data is swiftly retrieved and analyzed.",
            },
            {
              img: "/assets/DataAnalytics/PowerBI/dashboard.png",
              title: "Powerful Dashboards",
              desc: "Power BI's best feature is its data-driven dashboards, which can be tailored to any enterprise's specific requirements. To offer a consistent user experience, you may easily embed the dashboards and BI reports in the applications.",
            },
            {
              img: "/assets/DataAnalytics/PowerBI/report.png",
              title: "Real-time Reporting",
              desc: "With actionable reports that are in line with your KPIs and brand, create a data experience that is unparalleled with Power BI. The tool enables you to generate reports and set up automatic data refresh so that all users may see the most recent data.",
            },
          ].map((item, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                borderRadius: "3%",
                textAlign: "center",
                border: "0.5px solid #FFC3EA",
                boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
                display: "flex",
                flexDirection: "column",
                background:
                  "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
                width: { xs: "90%", sm: "250px" },
                height: { xs: "auto", sm: "420px" },
                padding: "2%",
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  width: "30%",
                  height: "auto",
                  margin: "0 auto",
                  paddingTop: "10%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  lineHeight: "120%",
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  color: "#F005A2",
                  padding: "10% 5% 0",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: { xs: "14px", sm: "14px" },
                  padding: "5% 5% 3%",
                }}
              >
                {item.desc}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>

      <Box>
        <Box sx={{ maxWidth: "100%", height: "auto", marginTop: "10%" }}>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "24px", sm: "32px", md: "40px", lg: "60px" }, // Responsive font size
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "center",
              paddingBottom: { xs: "5%", sm: "4%", md: "3%", lg: "1%" }, // Responsive padding
            }}
          >
            Technologies
          </Typography>
        </Box>
      </Box>

      <Container
        sx={{
          height: "auto",
          backgroundColor: "#fff",
          maxWidth: "100% !important",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Stack
          className="clientImagCont"
          direction="row"
          spacing={0}
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            padding: "2% 0 3% 0",
            gap: "6%",
            animation: "clientImagCont 30s linear infinite",
          }}
        >
          {Array.from({ length: 4 }).flatMap(() =>
            [
              "/assets/DataAnalytics/PowerBI/tech1.png",
              "/assets/DataAnalytics/PowerBI/tech2.png",
              "/assets/DataAnalytics/PowerBI/tech3.png",
              "/assets/DataAnalytics/PowerBI/tech4.png",
              "/assets/DataAnalytics/PowerBI/tech5.png",
              "/assets/DataAnalytics/PowerBI/tech6.png",
              "/assets/DataAnalytics/PowerBI/tech7.png",
            ].map((src, index) => (
              <img
                key={`${src}-${index}`}
                alt=""
                src={src}
                style={{
                  width:
                    src.includes("tech5") || src.includes("tech6")
                      ? "7%"
                      : "10%",
                  height: "5%",
                  paddingTop: src.includes("tech4") ? "1%" : "0",
                }}
              />
            ))
          )}
        </Stack>
      </Container>

      <Box>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            padding: { xs: "3% 0", sm: "4% 0", md: "5% 0" }, // Responsive padding
          }}
        >
          Our Big Data Engineering Services
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: "40px",
            paddingX: { xs: "5%", sm: "10%" },
            justifyContent: "center",
          }}
        >
          {[
            {
              img: "/assets/BigData/DW.png",
              title: "Power BI Deployment",
              text: "After a thorough evaluation process, our Power BI Experts create and carry out custom roadmaps and governance plans.",
            },
            {
              img: "/assets/BigData/DP.png",
              title: "Power BI Dashboards",
              text: "Using any device, you can access your customized dashboards and explore data visualizations with 360-degree views of your data in real time.",
            },
            {
              img: "/assets/BigData/DV.png",
              title: "SQL Server",
              text: "Our Power BI experts assist you in enhancing SQL Server's capacity to make use of intelligent data integration, reporting, and analysis.",
            },
            {
              img: "/assets/BigData/DW.png",
              title: "Power BI Embedded",
              text: "With our Power BI embedded services, you can get interactive reporting solutions to help you get a faster time to market. Incorporate Power BI reports with your current systems.",
            },
            {
              img: "/assets/BigData/DP.png",
              title: "Data Analytics & Reporting",
              text: "Our Power BI consultants employ cutting-edge analytics technology to extract the most valuable insights from your data to forecast opportunities, avert falls, and make data-driven decisions.",
            },
            {
              img: "/assets/BigData/DV.png",
              title: "Support & Assistance",
              text: "We offer Power BI license management, maintenance, and support services, including installs, setups, and integrations specifically tailored to meet your requirements.",
            },
          ].map((service, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                borderRadius: "12px",
                textAlign: "center",
                border: "0.5px solid #FFC3EA",
                boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
                display: "flex",
                flexDirection: "column",
                background:
                  "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
                padding: "20px",
                height: { xs: "auto", md: "400px" },
              }}
            >
              <img
                src={service.img}
                alt={service.title}
                style={{
                  width: "15%",
                  height: "auto",
                  margin: "0 auto",
                  paddingTop: "10%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  fontSize: { xs: "18px", sm: "22px", md: "28px" },
                  fontWeight: "700",
                  color: "#F005A2",
                  paddingTop: "10%",
                }}
              >
                {service.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "10% 5%",
                }}
              >
                {service.text}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: "6%",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            textAlign: "center",
            paddingBottom: { xs: "3%", md: "5%" },
          }}
        >
          Why Tecloq?
        </Typography>
      </Box>

      <WhyTecloqCards data={whydata} />
    </Box>
  );
};

export default PowerBI;
